





















































































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import DatePickersMethods from '@/mixins/DatePickersMethods.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import EditPresentationParticipantData from '@/ts/EditPresentationParticipantData';
import PreviewEmailButton from '@/components/Admin/Layout/PreviewEmailButton.vue';
import { dateFormat, dateTimeFormat } from '@/ts/DefaultTableConfigs';
import NotifyMethods from '@/mixins/NotifyMethods.vue';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';
import DateMethods from '@/mixins/DateMethods.vue';

@Component({
    components: {
        DatePicker,
        FlexibleTable,
        PreviewEmailButton,
    },
})
export default class AssignTenant extends Mixins(DatePickersMethods, LocalizationMethods, NotifyMethods, DateMethods) {
    public tableEntity: string = 'AssignTenant';
    public assignDeadlineDate: string = '';
    public messageToAssignApplicant: string = '';
    public datePickers: string[] = ['presentation'];
    public smsNotification: boolean = false;

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'createdAt', label: this.$t('general.application-date', 'Application date'), align: 'left', field: 'createdAt', required: false, sortable: true, filterType: 'date', dateFormat: dateTimeFormat,
                sort: (a: any, b: any) => {
                    const aTimestamp = a !== '' ? this.$moment(a, dateTimeFormat).valueOf() : 0;
                    const bTimestamp = b !== '' ? this.$moment(b, dateTimeFormat).valueOf() : 0;

                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'interestedFrom', label: this.$t('general.application-interest-from', 'Interest from'), align: 'left', field: 'interestedFrom', sortable: true, required: false, filterType: 'date', dateFormat },
            { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true, required: false },
            { name: 'email', label: this.$t('general.email', 'E-mail'), align: 'left', field: 'email', sortable: true, required: false },
            { name: 'phone', label: this.$t('general.phone', 'Phone'), align: 'left', field: 'phone', sortable: true, required: false },
            { name: 'language', label: this.$t('general.language', 'Language'), align: 'left', field: 'language', sortable: true, required: false },
            { name: 'priority', label: this.$t('general.priority', 'Priority'), align: 'left', field: 'priority', sortable: true, required: false },
            { name: 'interested', label: this.$t('general.interested', 'Interested'), align: 'left', field: 'interested', sortable: true, required: false },
        ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'name',
                'email',
                'phone',
                'priority',
                'interested',
            ],
        };
    }

    get currentEditPresentation() {
        return this.$store.getters['PresentationFlows/getCurrentEditPresentation'];
    }

    get tableData(): EditPresentationParticipantData[] {
        return this.$store.getters['PresentationFlows/getCurrentEditPresentationParticipants'];
    }

    public loadPreviewEmailOverlay(templateId: any ) {
        const data = {
            templateId,
            presentationId: this.currentEditPresentation.id,
            deadlineDate: this.assignDeadlineDate,
            message: this.messageToAssignApplicant,
        };

        this.$store.dispatch(Actions.FETCH_TEMPLATE_RENDERER, data);
    }

    public assignTenant(applicationId: number)  {
        if (this.assignDeadlineDate === '') {
            return this.notify('deadline_date_is_required', 'warning');
        }

        if (new Date().getTime() > new Date(this.assignDeadlineDate).getTime()) {
            return this.notify('deadline_date_should_be_later_then_today', 'warning');
        }

        this.$store.dispatch(Actions.ASSIGN_TENANT, {
            smsNotification: this.smsNotification,
            message: this.messageToAssignApplicant,
            applicationId,
            deadlineDate: this.assignDeadlineDate,
            presentationId: this.currentEditPresentation.id,
        });
    }

    public closeOffer(presentationId: number) {
        this.$store.dispatch(Actions.CLOSE_OFFER, presentationId);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ASSIGN_TENANT_VISIBILITY, false);
    }
}
